import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { Error } from "../../../../../commons/Messages/Messages";
import ProjectLists from "../../../../../commons/Projects/ProjectLists";
import { SocketContext } from "../../../../../context/SocketContext";
import { isAuthenticated } from "../../../../../commons/Auth/auth";

const EmployeeProjects = ({ employeeObject }) => {
  const socket = useContext(SocketContext);
  const [projectsArray, setProjectsArray] = useState([]);
  const [totalProjectsCount, setTotalProjectsCount] = useState("");
  const [searchProjectText, setSearchProjectText] = useState("");
  const [projectsPageNo, setProjectsPageNo] = useState(1);
  const [projectPageSize] = useState(15);

  const handleSearch = value => {
    setSearchProjectText(value);
    setProjectsPageNo(1);
  };

  const getData = async () => {
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/projects/limited`,
        {
          employee: employeeObject?._id,
          searchText: searchProjectText,
          pageSize: projectPageSize,
          pageNo: projectsPageNo - 1
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          setProjectsArray(res.data.data);
          setTotalProjectsCount(res.data.count);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        if (err.response?.data?.errorMessage) {
          Error(err.response?.data?.errorMessage);
        } else {
          Error(err.message);
        }
      });
  };

  const refreshData = () => {
    getData();
  };

  useEffect(() => {
    if (socket) {
      socket.on("refresh service provider data", msg => {
        if (msg) {
          refreshData();
        }
      });
    }
  }, [socket]);

  useEffect(() => {
    employeeObject?._id && getData();

    return () => { };
  }, [searchProjectText, projectsPageNo, employeeObject]);

  return (
    <div>
      <ProjectLists
        serviceProvider={true}
        serviceProviderId={
          isAuthenticated()?.employer?._id
            ? isAuthenticated()?.employer?._id
            : isAuthenticated()?.serviceProviderId
        }
        projectsArray={projectsArray}
        handlePageChange={val => setProjectsPageNo(val)}
        handleSearch={handleSearch}
        updateParent={refreshData}
        totalCount={totalProjectsCount}
        pageNo={projectsPageNo}
        pageSize={projectPageSize}
        employeeObject={employeeObject}
      />
    </div>
  );
};

export default EmployeeProjects;
